import { useEffect, useState, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logo from '../../assets/images/atlas-controls-icon.png';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { AuthContext } from '../../common/contexts/AuthContext';
import useAuthorization from '../../common/hooks/useAuthorization';

import useApplicationService from '../../common/hooks/useApplicationService';

function Footer() {
  const [loading, setLoading] = useState(true);
  const [version, setVersion] = useState('0');
  const [application, setApplication] = useState('[application]');
  const service = useApplicationService();
  const { sessionHelpers } = useContext(AuthContext);

  useEffect(() => {
    async function LoadData() {
      const response = await service.getVersion();
      if (response && response.ok) {
        setVersion(response.data);
      }

      const respApp = await service.getApplication();
      if (respApp && respApp.ok) {
        setApplication(respApp.data);
      }
    }
    if (loading) {
      LoadData();
      setLoading(false);
    }
  }, [loading, service, sessionHelpers]);

  return (
    <footer className="text-white text-sm bg-adg-darkblue mt-4">
      <div className="w-full bg-adg-bg">
        <img
          src="/footer.png"
          className="bg-adg-bg"
          style={{ width: '100%', height: '65px' }}
          alt="border"
        />
      </div>
      <div className="flex w-full">
        <div className="flex flex-row p-8 justify-center">
          <div className="p-4 max-w-[10%]">
            <img src={Logo} className="max-h-[110px]" size="5x" alt="logo" />
          </div>
          <div className="p-4 max-w-[30%]">
            <h4>Atlas Controls</h4>
            <p>
              The Atlas Controls application automates recurring taskers
              for Management Sections with the intention to prevent fraud, waste
              and abuse and enable management oversight of their statement of
              assurance tasks.
            </p>
            {/* <p>2/19/2025 {application}</p> */}
          </div>
          <div className="p-4 max-w-[15%]">
            <h4>Quick Links</h4>
            <div className="m-1">
              <a
                className="text-white"
                target="blank"
                href="https://adggap.state.gov/"
              >
                ADG Global Application Portal
              </a>
            </div>
            <div className="m-1">
              <a
                className="text-white"
                target="blank"
                href="https://adgsupport.state.gov"
              >
                ADG Help Desk
              </a>
            </div>
            <div className="m-1">Version {version}</div>
          </div>
          <div className="p-4 max-w-[30%]">
            <div className="text-center m-1">
              <img
                src="/adg-light-no-text.png"
                alt="ADG"
                className="max-h-[110px]"
              />
            </div>
            <div className="text-center m-1">
              <small>{'<Application Development Group>'}</small>
            </div>
            <div className="text-center m-1">
              <small>
                <a
                  href="mailto:ADG-Support@state.gov"
                  className="text-white text-decoration-none"
                >
                  <FontAwesomeIcon className="me-1" icon={faEnvelope} />
                  ADG-Support@state.gov
                </a>
              </small>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
